/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppDeleteFragmentDetailByIdMutationResponse, WebAppDeleteFragmentDetailByIdPathParams, WebAppDeleteFragmentDetailById401, WebAppDeleteFragmentDetailById403, WebAppDeleteFragmentDetailById404 } from "../models/WebAppDeleteFragmentDetailById";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppDeleteFragmentDetailById } from "../axios/webAppDeleteFragmentDetailById";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppDeleteFragmentDetailByIdMutationKey = () => [{ url: '/web-app/v1/fragments/:id' }] as const

export type WebAppDeleteFragmentDetailByIdMutationKey = ReturnType<typeof webAppDeleteFragmentDetailByIdMutationKey>

export function webAppDeleteFragmentDetailByIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = webAppDeleteFragmentDetailByIdMutationKey()
        return mutationOptions<WebAppDeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<WebAppDeleteFragmentDetailById401 | WebAppDeleteFragmentDetailById403 | WebAppDeleteFragmentDetailById404>, {id: WebAppDeleteFragmentDetailByIdPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return webAppDeleteFragmentDetailById(id, config)
          },
        })

}

/**
 * @summary Delete one fragment by id
 * {@link /web-app/v1/fragments/:id}
 */
export function useWebAppDeleteFragmentDetailById<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppDeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<WebAppDeleteFragmentDetailById401 | WebAppDeleteFragmentDetailById403 | WebAppDeleteFragmentDetailById404>, {id: WebAppDeleteFragmentDetailByIdPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppDeleteFragmentDetailByIdMutationKey()

          const baseOptions = webAppDeleteFragmentDetailByIdMutationOptions(config) as UseMutationOptions<WebAppDeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<WebAppDeleteFragmentDetailById401 | WebAppDeleteFragmentDetailById403 | WebAppDeleteFragmentDetailById404>, {id: WebAppDeleteFragmentDetailByIdPathParams["id"]}, TContext>
          

          return useMutation<WebAppDeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<WebAppDeleteFragmentDetailById401 | WebAppDeleteFragmentDetailById403 | WebAppDeleteFragmentDetailById404>, {id: WebAppDeleteFragmentDetailByIdPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppDeleteFragmentDetailByIdMutationResponse, ResponseErrorConfig<WebAppDeleteFragmentDetailById401 | WebAppDeleteFragmentDetailById403 | WebAppDeleteFragmentDetailById404>, {id: WebAppDeleteFragmentDetailByIdPathParams["id"]}, TContext>
      
}